import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators ,NgForm} from '@angular/forms';
import { CommonService } from 'app/auth/service/common.service';
import Swal from 'sweetalert2';
import { documentType, ParentParameters, statusCode,applicationFrom } from '../../../auth/models/commonEnum';
import { NgbCalendar, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, debounceTime, distinctUntilChanged, filter, first, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { FileUploader } from 'ng2-file-upload';
import { ActivatedRoute, Router } from '@angular/router';
import { MyApplicationService } from '../my-application.service';

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent implements OnInit {
  public user_data;
  public contentHeader;
	public addExpertForm : FormGroup;
	public submitted: boolean;
	public passwordTextType: boolean;
	public loading: boolean;
	public subjectType: any[];
	public CategoryType : any[];
	public maxDate = this.calendar.getToday();
	public minDate = this.calendar.getPrev(this.calendar.getToday(), 'y', 100);
	public minDOBDate = this.calendar.getPrev(this.calendar.getToday(), 'y', 100);
	public endminDate = (this.minDate != undefined && this.minDate != null) ? this.minDate : this.calendar.getToday();
	public identityProofType = [];
	public countryData = [];
	public stateData: any[];
	public districtData: any[];
	public cityData: any[];
	public profileFiles: any[];
	public existingId: string;
	public isDisabled: boolean;
	public DOB: any;
	public expertDetails: any;
	public profileURL: any;
	public selected: { id: number; name: string; }[];
	public isEdit: boolean;
	public department: any[];
	public categoryDataArray: any;
	public departmentDataArray: any;
	public departmentDetailsArray: any;
	public categoryArray: any[];
	public categorySelectedIds: any;
	constructor(
		private _formBuilder : FormBuilder,
		private _commonService: CommonService,
		private calendar: NgbCalendar,
		private route: ActivatedRoute,
		private _router: Router,
		private _myApplicationService: MyApplicationService,
	) {
		this.addExpertForm = this._formBuilder.group({
			FirstName: ["", [Validators.required]],
			LastName: ["", [Validators.required]],
			Email: ["", [Validators.required, Validators.email]],
			Mobile: ["", [Validators.maxLength(15),Validators.minLength(10)]],
			Password: ['', [Validators.required]],
			ConfirmPassword: ['', [Validators.required]],
			Category: ['', [Validators.required]],
			Subject:['', [Validators.required]],
			UserRole:['Expert'],
			title : [''],
			dateOfBirth : [],
			gender: ["M"],
			department:['',[Validators.required]],
			designation:[''],
			identityProof:[0],
			institute:[''],
			instituteAddress:[''],
			customerAddress:[''],
			country:[0],
			state:[0],
			city:[0],
			pincode:[''],
			profileDoc:[],
			profileDocName:['Select File'],
		});
		this.route.params.subscribe(parmas => {
			this.existingId = parmas["id"];
		});
		this.contentHeader = {
			headerTitle: 'View User',
			actionButton: true,
			breadcrumb: {
				type: '',
				links: [
					{
						name: 'Registered User',
						isLink: true,
						link: '/customer-list'
					},
					{
						name: 'View User',
						isLink: false,
					},
				]
			}
		};
		
		
	}

	ngOnInit(): void {
		this.isEdit = false;
		this.loadSubjectAreaType('',false);
		// this.loadExpertCategoryType();
		this.loadIdentityProofData();
		this.loadCountryData();
		this.loadStateData(0);
		this.loadCityData(0);
		// this.addExpertForm.get('Category').setValidators([Validators.required]);
		// this.addExpertForm.get('identityProof').setValidators([Validators.required]);
		// this.addExpertForm.get('country').setValidators([Validators.required]);
		// this.addExpertForm.get('state').setValidators([Validators.required]);
		// this.addExpertForm.get('city').setValidators([Validators.required]);
		if(this.existingId != undefined){
			this.getExpertDetailAndMapData(this.existingId);
		}
	}
	public getExpertDetailAndMapData(expertId){
		this.isEdit = true;
		const data = {
			expertId: expertId
		}
		this._myApplicationService.getUserData(data).subscribe((result: any) => {
     
      
			this.expertDetails = null;
			if (result.statusCode == statusCode.SUCCESS) {
				this.expertDetails 	= result["data"];
        this.user_data = this.expertDetails;
				let subjectDataArray: any;
				subjectDataArray = [];
				let subjectDetailsArray : any;
				subjectDetailsArray = [];
				if(this.expertDetails.subjectArea != 0 && this.expertDetails.subjectArea.split(",").length > 0)
				{
					this.expertDetails.subjectArea.split(",").forEach(element => {
						subjectDataArray.push(parseInt(element));
						subjectDetailsArray.push({
							subjectTypeID:parseInt(element)
						})
					});
				}
				this.departmentDataArray = [];
				this.departmentDetailsArray = [];
				if(this.expertDetails.department.split(",").length > 0)
				{
					this.expertDetails.department.split(",").forEach(element => {
						this.departmentDataArray.push(parseInt(element));
						this.departmentDetailsArray.push({
							departmentID:parseInt(element)
						})
					});
				}
				this.categoryDataArray = [];
				if(this.expertDetails.category.split(",").length > 0)
				{
					this.expertDetails.category.split(",").forEach(element => {
						this.categoryDataArray.push(parseInt(element));
					});
				}
				this.subjectChange(subjectDetailsArray,true);
				this.departmentChange(this.departmentDetailsArray,true);
				this.loadSubjectAreaType(subjectDataArray,true);
				this.addExpertForm.controls.FirstName.setValue(this.expertDetails.firstName);
				this.addExpertForm.controls.LastName.setValue(this.expertDetails.lastName);
				this.addExpertForm.controls.Email.setValue(this.expertDetails.email);
				this.addExpertForm.controls.Mobile.setValue(this.expertDetails.mobile);
				this.addExpertForm.controls.UserRole.setValue(this.expertDetails.userRoles);
				this.addExpertForm.controls.title.setValue(this.expertDetails.title);
				this.addExpertForm.controls.title.setValue(this.expertDetails.title);
				this.addExpertForm.controls.gender.setValue(this.expertDetails.gender);
				// this.addExpertForm.controls.department.setValue(this.expertDetails.department);
				this.addExpertForm.controls.designation.setValue(this.expertDetails.designation);
				if(this.expertDetails.identityProof){
					this.addExpertForm.controls.identityProof.setValue(this.expertDetails.identityProof);
				}
				this.addExpertForm.controls.institute.setValue(this.expertDetails.institute);
				this.addExpertForm.controls.instituteAddress.setValue(this.expertDetails.instituteAddress);
				this.addExpertForm.controls.customerAddress.setValue(this.expertDetails.customerAddress);
				this.addExpertForm.controls.pincode.setValue(this.expertDetails.pincode);
				if(this.expertDetails.country){
					this.addExpertForm.controls.country.setValue(this.expertDetails.country);
					this.loadStateData(this.expertDetails.country);
				}
				if(this.expertDetails.state){
					this.addExpertForm.controls.state.setValue(this.expertDetails.state);
					this.loadCityData(this.expertDetails.state);
				}
				if(this.expertDetails.city){
					this.addExpertForm.controls.city.setValue(this.expertDetails.city);
				}
				this.profileURL = this.expertDetails.profilePhoto;
				let [year, month, day] = ['','',''];
				let obj = null;
				let bDate = this.expertDetails.dateOfBirth;
				if(this.isValidData(bDate)){
					[year, month, day] = bDate.split('-');
				obj = { year: parseInt(year), month: parseInt(month), day: 
					parseInt(day.split(' ')[0].trim()) };
				}
				this.addExpertForm.controls.dateOfBirth.setValue(obj);
			}
		});
	}
	get getExpertDetails() {
		return this.addExpertForm.controls;
	}

	clearValidation() {
		this.addExpertForm.get('Password').clearValidators();
		this.addExpertForm.controls.Password.setValue("");
		this.addExpertForm.get('ConfirmPassword').clearValidators();
		this.addExpertForm.controls.ConfirmPassword.setValue("");
	}

	/**
	 * On Submit
	 */
	onSubmit() {
		this.submitted = true;
		this.isDisabled = true;
		if(this.isEdit)
		{
			this.clearValidation();
		}
		this.addExpertForm.controls.dateOfBirth.clearValidators();
		//this.addExpertForm.get('dateOfBirth').clearValidators();
		if (this.addExpertForm.invalid) {
			return false;
		}
		
		this.loading = true;
		this.DOB = this.addExpertForm.controls.dateOfBirth.value;
		if (this.DOB != null && this.DOB != undefined) {
			this.DOB = this.DOB.year + '-' + this.DOB.month + '-' + this.DOB.day;
		}
		const data = this.prepareData();
		this._myApplicationService
		.saveExpertDetails(data)
		.pipe(first())
		.subscribe(
			response => {
				if (Number(response["statusCode"]) === statusCode.SUCCESS) {
					this.isDisabled = false;
					this.submitted = false;
					Swal.fire({
						icon: 'success',
						title: 'Success!',
						text: 'Expert Details Updated successfully.',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					this._router.navigate(['/expert-list']);
				}
				else {
					this.loading = false;
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: response["message"],
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			},
			error => {
				//this.error = error;
				this.isDisabled = false;
				this.loading = false;
				Swal.fire({
					icon: 'error',
					title: 'Error!',
					text: error,
					customClass: {
						confirmButton: 'btn btn-error'
					}
				});
			}
		);

		return false;
	}
	/**
	 * Toggle password
	 */
	togglePasswordTextType() {
		this.passwordTextType = !this.passwordTextType;
	}

	/**
	 * function for load status type dropdown data.
	 ***/
	loadExpertCategoryType() {
		this._commonService.getParameterSettings(ParentParameters.EXPERT_CATEGORIES).subscribe((result: any) => {
			// this.CategoryType = [];
			if (result.statusCode == statusCode.SUCCESS) {
				result["data"]["response"].forEach(element => {
					this.CategoryType.push({
						categoryTypeName: element.paraDescription,
						categoryTypeID: element.paraId
					});
				});
			}
		});
	}

	loadIdentityProofData() {
		this._commonService.getParameterSettings(ParentParameters.IDENTITY_PROOF).subscribe((result: any) => {
			this.identityProofType = [];
			this.identityProofType.push({
				identityProofTypeName: "Select Identity Proof Type",
				identityProofTypeID: 0
			});
			if (result.statusCode == 200) {
			result["data"]["response"].forEach(element => {
				this.identityProofType.push({
				identityProofTypeName: element.paraDescription,
				identityProofTypeID: element.paraId
				});
			});
			}
		});
	}
	
	loadCountryData() {
		this._commonService.getCountryData().subscribe((result: any) => {
			this.countryData = [];
			this.countryData.push({
				countryName: "Select Country",
				countryID: 0
			});
			if (result.data.response.length > 0) {
			result["data"]["response"].forEach(element => {
				this.countryData.push({
					countryName: element.name,
					countryID: element.id
				});
			});
			}
		});
	}

	countryChange(id: number) {
		this.stateData = [];
		this.districtData = [];
		this.cityData = [];
		if(id > 0){
			this.loadStateData(id);
		}
		else{
			this.addExpertForm.controls.state.setValue(0);
			this.addExpertForm.controls.city.setValue(0);
			this.loadStateData(0);
			this.loadCityData(0);
		}
	}

	loadStateData(countryID: number) {
		this._commonService.getStateData(countryID).subscribe((result: any) => {
			this.stateData = [];
			this.stateData.push({
				stateName: "Select State",
				stateID: 0
			});
			
			if (result.data.response != undefined && result.data.response.length > 0) {
			result["data"]["response"].forEach(element => {
				this.stateData.push({
					stateName: element.name,
					stateID: element.id
				});
			});
			}
		});
	}

	stateChange(stateID: number) {
		this.districtData = [];
		this.cityData = [];
		if(stateID > 0){
			this.loadCityData(stateID);
		}
		else{
			this.addExpertForm.controls.city.setValue(0);
			this.loadCityData(0);
		}
	}

	loadCityData(stateID: number) {
	  	this._commonService.getCityData(stateID).subscribe((result: any) => {
			this.cityData = [];
			this.cityData.push({
				cityName: "Select City",
				cityID:0
			});
			if (result.data.response != undefined && result.data.response.length > 0) {
				result["data"]["response"].forEach(element => {
					this.cityData.push({
						cityName: element.name,
						cityID: element.id
					});
				});
			}
	 	});
	}

	/**
	* function get uploaded file on upload file change.
	***/
	uploadProfilefileChange(event: any, fileSize) {
		for (var i = 0; i < event.target.files.length; i++) {
			var filetype = event.target.files[i].type;
			if(filetype != 'image/png' && filetype != 'image/jpeg' && filetype != 'image/jpg'){
				Swal.fire({
					title: 'Information',
					text: 'Invalid file type. Please upload image only.',
					icon: 'info',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
				return false;
			}
			var size = event.target.files[i].size;
			size = (size / 1024 / 1024);
			if(size > fileSize){
				Swal.fire({
					title: 'Information',
					text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
					icon: 'info',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
				return false;
			}
			this.profileFiles = [];
			var key = "ProfileFiles";
			this.profileFiles.push({ key: key, file: event.target.files[i] });
			this.addExpertForm.controls.profileDocName.setValue(this.showFiles(this.profileFiles));
		}
	}

	/**
	* function return selected file name.
	***/
	showFiles(documentsList: any) {
		let files = '';
		for (let i = 0; i < documentsList.length; i++) {
			files += documentsList[i].file.name;

			if (!(documentsList.length - 1 === i)) {
				files += ',';
			}
		}
		return files;
	}
	browsbuttonClick(type) {
		if (type === 'profilePicture') {
			this.addExpertForm.controls.profileDocName.setValue("Select File");
		}
	}
	isValidData(data){
		if(data != null && data != undefined && data != ''){
			return true;
		}
		return false;
	}
	prepareData(): any{
		let input: FormData = new FormData();
		input.append('expertId', this.existingId);
		input.append('FirstName',this.addExpertForm.controls.FirstName.value);
		input.append('LastName',this.addExpertForm.controls.LastName.value);
		input.append('Email', this.addExpertForm.controls.Email.value);
		input.append('Mobile', this.addExpertForm.controls.Mobile.value);
		input.append('Subject', this.addExpertForm.controls.Subject.value);

		input.append('UserRole',this.addExpertForm.controls.UserRole.value);
		input.append('city', this.addExpertForm.controls.city.value);
		input.append('country',this.addExpertForm.controls.country.value);
		input.append('customerAddress',this.addExpertForm.controls.customerAddress.value);
		input.append('dateOfBirth', this.DOB);
		input.append('department',this.addExpertForm.controls.department.value);

		input.append('designation',this.addExpertForm.controls.designation.value);
		input.append('gender',this.addExpertForm.controls.gender.value);
		input.append('identityProof',this.addExpertForm.controls.identityProof.value);
		input.append('institute',this.addExpertForm.controls.institute.value);

		input.append('instituteAddress',this.addExpertForm.controls.instituteAddress.value);
		input.append('pincode',this.addExpertForm.controls.pincode.value);
		input.append('state',this.addExpertForm.controls.state.value);
		input.append('title',this.addExpertForm.controls.title.value);
		input.append('Password',this.addExpertForm.controls.Password.value);
		input.append('category',this.addExpertForm.controls.Category.value);

		if(this.profileFiles){
			for (var i = 0; i < this.profileFiles.length; i++) {
				input.append(this.profileFiles[i].key, this.profileFiles[i].file);
			}
		}
		
		return input;
	}

	/**
	 * function for load subject area
	 ***/
	loadSubjectAreaType(selectedId,isEdit) {
		this._commonService.getParameterSettings(ParentParameters.SUBJECTAREA).subscribe((result: any) => {
			this.subjectType = [];
			if (result.statusCode == statusCode.SUCCESS) {
				result["data"]["response"].forEach(element => {
					this.subjectType.push({
						subjectTypeName: element.paraDescription,
						subjectTypeID: element.paraId
					});
				});
				if(isEdit){
					let subjectMap 		= this.subjectType.map(item => { return item.subjectTypeID});
					let filteredSubject = selectedId.filter(itemZ => { return subjectMap.includes(itemZ)})
					this.addExpertForm.controls.Subject.setValue(filteredSubject);
				}
			}
		});
		
	}
	/**
	 * function for load subject area
	 ***/
	subjectChange(subjectTypeIds: any,isEdit){
		if(isEdit){
			var departmentSelectedIds = this.departmentDataArray
		}else{
			var departmentSelectedIds = this.addExpertForm.controls.department.value
		}
		const subjectArray = [];
		subjectTypeIds.forEach(element => {
			subjectArray.push(element.subjectTypeID);
		});
		if(subjectArray.length == 0){
			this.addExpertForm.controls.department.setValue('');
			this.addExpertForm.controls.Category.setValue('');
		}
		this._commonService.getDepartmentFromSubject(subjectArray).subscribe((result: any) => {
			this.department = [];
			if (result.statusCode == statusCode.SUCCESS) {
				result["data"]["response"].forEach(element => {
					this.department.push({
						departmentName: element.paraDescription,
						departmentID: element.paraId,
						departmentSubjectId : element.paraParentId
					});
				});
				if(departmentSelectedIds.length > 0){
					let departmentMap = this.department.map(itemY => { return itemY.departmentID; });
					let filtered = departmentSelectedIds.filter(itemX => { return departmentMap.includes(itemX) });
					this.addExpertForm.controls.department.setValue(filtered);
				}
				
			}
		});
	}
	departmentChange(departmentIds:any,isEdit){
		if(isEdit){
			this.categorySelectedIds = this.categoryDataArray
		}else{
			this.categorySelectedIds = this.addExpertForm.controls.Category.value
		}
		const departmentArray 	= [];
		departmentIds.forEach(element => {
			departmentArray.push(element.departmentID);
		});
		if(departmentArray.length == 0){
			this.addExpertForm.controls.Category.setValue('');
		}
		this._commonService.getCategoryFromDepartment(departmentArray).subscribe((result: any) => {
			this.CategoryType 		= [];
			if (result.statusCode == statusCode.SUCCESS) {
				result["data"]["response"].forEach(element => {
					this.CategoryType.push({
						categoryTypeName: element.paraDescription,
						categoryTypeID: element.paraId
					});
				});
				if(this.categorySelectedIds.length > 0){
					let categoryMap 		= this.CategoryType.map(itemY => { return itemY.categoryTypeID; });
					let filteredCategory 	= this.categorySelectedIds.filter(itemX => { return categoryMap.includes(itemX) });
					this.addExpertForm.controls.Category.setValue(filteredCategory);
				}
			}
		});
	}

}
